import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "components/bootstrap";
import { hasAttribute, optionableLabel } from "components/configurationforms/FieldHelpers";
import { getValueFromInput } from "util/FormsUtils";
const TextField = ({ field, title, typeName, dirty = false, onChange, value = "", autoFocus = false }) => {
  const { t } = useTranslation("common");
  const isRequired = !field.is_optional;
  const showReadOnlyEncrypted = field.is_encrypted && !dirty && typeof value !== "string" && value.is_set;
  const fieldType = !hasAttribute(field.attributes, "textarea") && (hasAttribute(field.attributes, "is_password") || showReadOnlyEncrypted) ? "password" : "text";
  const fieldId = `${typeName}-${title}`;
  const [isResetted, setIsResetted] = useState(false);
  const getFieldValue = () => {
    if (showReadOnlyEncrypted) return "encrypted placeholder";
    if (typeof value === "string") return value;
    if (value && value.set_value) {
      return value.set_value;
    }
    return "";
  };
  const handleChange = ({ target }) => {
    const inputValue = getValueFromInput(target);
    if (field.is_encrypted) {
      onChange(title, { set_value: String(inputValue) });
    } else {
      onChange(title, String(inputValue));
    }
  };
  const handleReset = () => {
    setIsResetted(true);
    onChange(title, { delete_value: true });
  };
  const handleUndoReset = () => {
    setIsResetted(false);
    onChange(title, { is_set: true }, false);
  };
  const buttonAfter = () => {
    if (isResetted) {
      return /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: handleUndoReset }, t("configuration_forms.undo_reset"));
    }
    if (!showReadOnlyEncrypted) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: handleReset }, t("actions.reset"));
  };
  if (hasAttribute(field.attributes, "textarea")) {
    return /* @__PURE__ */ React.createElement(
      Input,
      {
        id: fieldId,
        type: "textarea",
        rows: 10,
        label: optionableLabel(field),
        name: `configuration[${title}]`,
        required: isRequired,
        help: field.description,
        value: getFieldValue(),
        onChange: handleChange,
        autoFocus
      }
    );
  }
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: fieldId,
      type: fieldType,
      name: `configuration[${title}]`,
      label: optionableLabel(field),
      required: isRequired,
      help: field.description,
      value: getFieldValue(),
      readOnly: showReadOnlyEncrypted,
      onChange: handleChange,
      buttonAfter: buttonAfter(),
      autoFocus
    }
  );
};
export default TextField;
